export default class GameMap{
    id!: string;
    universeId!: string;
    name = '';
    description = '';
    size = '';
    location = '';

    constructor(data?: any) {
        if (data) {
            if (typeof data !== "object") data = JSON.parse(data);
            Object.assign(this, data);
        }
    }
}
